const PartnerInformationFormFields = [
  {
    componentType: "text",
    label: "Full Name",
    id: "PartnerProfile_full_name",
    pinCondition: "left",
    disabled: true,
  },
  {
    componentType: "dropdown",
    label: "Title",
    id: "PartnerProfile_title",
    optionsKey: "title_id",
  },
  {
    componentType: "text",
    label: "First name",
    id: "PartnerProfile_first_name",
    required: true,
  },
  {
    componentType: "text",
    label: "Middle name",
    id: "PartnerProfile_middle_name",
  },
  {
    componentType: "text",
    label: "Last name",
    id: "PartnerProfile_last_name",
    required: true,
  },
  {
    componentType: "multiSelect",
    label: "Suffix",
    id: "PartnerProfile_suffix",
    addNewOption: true,
    optionsKey: "suffix_id",
    dropDown: "Suffix",
    field_name: "suffix",
  },
  {
    componentType: "text",
    label: "Company name",
    id: "PartnerProfile_company_name",
  },
  {
    componentType: "dropdown",
    label: "Person status",
    id: "PartnerProfile_person_status",
    required: true,
    optionsKey: "person_status_id",
  },
  {
    componentType: "multiSelect",
    label: "Candidate status",
    id: "PartnerProfile_candidate_status",
    optionsKey: "label",
  },
  {
    componentType: "multiSelect",
    label: "Nationality",
    id: "PartnerProfile_nationality",
    required: true,
    optionsKey: "nationality_list_id",
  },
  {
    componentType: "dropdown",
    label: "Gender",
    id: "PartnerProfile_gender",
    optionsKey: "gender_id",
  },
  {
    componentType: "multiSelect",
    label: "Type of partner",
    id: "PartnerProfile_type_of_partner",
    required: true,
    addNewOption: true,
    optionsKey: "profile_role_id",
    drop_down: "ProfileRole",
    field_name: "title",
  },
  {
    componentType: "dropdown",
    label: "Access level",
    id: "PartnerProfile_access_level",
    optionsKey: "access_levels",
  },
  {
    componentType: "text",
    label: "Authorisation provided by",
    id: "PartnerProfile_authorisation_provided_by",
  },
  {
    componentType: "multiSelect",
    label: "Organization panels",
    id: "PartnerProfile_organization_panels",
    optionsKey: "organisation_id",
  },
  {
    componentType: "datePicker",
    label: "Date of initial contact",
    id: "PartnerProfile_date_of_initial_contact",
    required: true,
  },
  {
    componentType: "dropdown",
    label: "Assignment sourced for",
    id: "PartnerProfile_assignment_sourced_for",
    required: true,
    optionsKey: "only_true_or_false",
  },
  {
    componentType: "dropdown",
    label: "Source type",
    id: "PartnerProfile_source_type",
    required: true,
    optionsKey: "source_id",
  },
  {
    componentType: "multiSelect",
    label: "Source company",
    id: "PartnerProfile_source_company",
    required: true,
    optionsKey: "source_referral1_id",
  },
  {
    componentType: "multiSelect",
    label: "Source person",
    id: "PartnerProfile_source_person",
    required: true,
    optionsKey: "source_referral3_id",
  },
  {
    componentType: "dropdown",
    label: "CV/Resume",
    id: "PartnerProfile_cv_resume",
    optionsKey: "only_true_or_false",
  },
  {
    componentType: "dropdown",
    label: "Send /Open questionnaire section",
    id: "PartnerProfile_send_open_questionnaire_section",
    optionsKey: "only_true_or_false",
  },
  {
    componentType: "dropdown",
    label: "Acuity profile created",
    id: "PartnerProfile_acuity_profile_created",
    required: true,
    optionsKey: "only_true_or_false",
  },
  {
    componentType: "dropdown",
    label: "BAME",
    id: "PartnerProfile_Bame",
    optionsKey: "only_true_or_false",
  },
  {
    componentType: "uploadFiles",
    label: "Passport",
    id: "PartnerProfile_passport",
    enableColumnFilter: false,
    enableGlobalFilter: false,
    enableSorting: false,
  },
  {
    componentType: "uploadFiles",
    label: "Visa",
    id: "PartnerProfile_visa",
    enableColumnFilter: false,
    enableGlobalFilter: false,
    enableSorting: false,
  },
  {
    componentType: "text",
    label: "Visa status",
    id: "PartnerProfile_visa_status",
  },
  {
    componentType: "multiSelect",
    label: "Languages",
    id: "PartnerProfile_lanuages",
    optionsKey: "language_list_id",
  },
  {
    componentType: "text",
    label: "Address",
    id: "PartnerProfile_address",
  },
  {
    componentType: "text",
    label: "Address1",
    id: "PartnerProfile_address_line1",
  },
  {
    componentType: "text",
    label: "Address2",
    id: "PartnerProfile_address_line2",
  },
  {
    componentType: "text",
    label: "City/town",
    id: "PartnerProfile_city",
  },
  {
    componentType: "text",
    label: "Country/state/region",
    id: "PartnerProfile_county",
  },
  {
    componentType: "text",
    label: "Post/zipcode",
    id: "PartnerProfile_zipcode",
  },
  {
    componentType: "dropdown",
    label: "Country",
    id: "PartnerProfile_country_list",
    optionsKey: "country_list_id",
  },
  {
    componentType: "text",
    label: "Email",
    id: "PartnerProfile_email",
    valdationType: "email",
    required: true,
  },
  {
    componentType: "text",
    label: "Secondary email",
    id: "PartnerProfile_secondary_email",
    validationType: "email",
  },
  {
    componentType: "text",
    label: "Mobile",
    id: "PartnerProfile_phone",
    validationType: "number",
  },
  {
    componentType: "text",
    label: "Telephone",
    id: "PartnerProfile_telephone",
    validationType: "number",
    required: true,
  },
  {
    componentType: "text",
    label: "PA name",
    id: "PartnerProfile_pa_name",
  },
  {
    componentType: "text",
    label: "PA contact details",
    id: "PartnerProfile_pa_conact_details",
  },
  {
    componentType: "text",
    label: "Office address",
    id: "PartnerProfile_office_address",
  },
  {
    componentType: "text",
    label: "Office phone",
    id: "PartnerProfile_business_phone",
    valdationType: "number",
  },
  {
    componentType: "text",
    label: "Office mobile",
    id: "PartnerProfile_business_mobile_number",
    validationType: "number",
  },
  {
    componentType: "text",
    label: "Location radius (km)",
    id: "PartnerProfile_location_radius",
  },
  {
    componentType: "text",
    label: "Linkedin",
    id: "PartnerProfile_linkedin",
  },
  {
    componentType: "text",
    label: "Skype",
    id: "PartnerProfile_skype",
  },
  {
    componentType: "text",
    label: "Twitter",
    id: "PartnerProfile_twitter",
  },
  {
    componentType: "text",
    label: "Facebook",
    id: "PartnerProfile_facebook",
  },
  {
    componentType: "text",
    label: "Website 1",
    id: "PartnerProfile_website1",
  },
  {
    componentType: "text",
    label: "Website 2",
    id: "PartnerProfile_website2",
  },
  {
    componentType: "dropdown",
    label: "Currently available for assignment",
    id: "PartnerProfile_currently_available_for_assignment",
    optionsKey: "only_true_or_false",
  },
  {
    componentType: "text",
    label: "Next available date",
    id: "PartnerProfile_next_available_date",
  },
  {
    componentType: "text",
    label: "General internal comments",
    id: "PartnerProfile_general_internal_comment",
  },
  {
    componentType: "dropdown",
    label: "Onboarded",
    id: "PartnerProfile_onboarded",
    optionsKey: "only_true_or_false",
  },
];

const PartnerPanelAccessField = [
  {
    componentType: "multiSelect",
    label: "Type of partner",
    id: "PartnerProfile_type_of_partner",
    optionsKey: "profile_role_id",
  },
  {
    componentType: "multiSelect",
    label: "Organization panels",
    id: "PartnerProfile_organization_panels",
    optionsKey: "organisation_panels",
  },
];

const PartnerNDAField = [
  {
    componentType: "text",
    label: "Name (For and on behalf of The Discloser)",
    id: "PartnerNda_sender_name",
  },
  {
    componentType: "datePicker",
    label: "Date (For and on behalf of The Discloser)",
    id: "PartnerNda_send_date",
  },
  {
    componentType: "text",
    label: "Name (The Recipient)",
    id: "PartnerNda_recipient_name",
  },
  {
    componentType: "datePicker",
    label: "Date (The Recipient)",
    id: "PartnerNda_recipient_date",
  },
];

const PartnerWWAField = [
  {
    componentType: "text",
    label: "First name",
    id: "PartnerWwa_first_name",
  },
  {
    componentType: "text",
    label: "Last name",
    id: "PartnerWwa_last_name",
  },
  {
    componentType: "datePicker",
    label: "Date",
    id: "PartnerWwa_date",
  },
];

const ParnterDiligenceField = [
  // {
  //   componentType: "datePicker",
  //   label: "Date",
  //   id: "PartnerDueDiligenceCall_available_date",
  // },
  // {
  //   componentType: "timePicker",
  //   label: "Time",
  //   id: "PartnerDueDiligenceCall_from",
  // },
  // {
  //   componentType: "text",
  //   label: "Due diligence notes",
  //   id: "PartnerDueDiligenceCall_internal_notes",
  // },
  // {
  //   componentType: "text",
  //   label: "Due diligence actions",
  //   id: "PartnerDueDiligenceCall_actions",
  // },
  {
    componentType: "customComponent",
    id: "PartnerDueDiligenceCall_due_diligence",
    label: "Due diligence call",
    customComponentProps: {
      handleChange: () => {},
      value: {},
      componentObject: [
        {
          componentType: "datePicker",
          label: "Date",
          type: "text",
          name: "PartnerDueDiligenceCall_date",
        },
        {
          componentType: "timePicker",
          label: "Time",
          type: "text",

          name: "PartnerDueDiligenceCall_from",
        },
        {
          componentType: "text",
          label: "Due diligence notes",
          type: "text",

          name: "PartnerDueDiligenceCall_internal_notes",
        },
        {
          componentType: "text",
          label: "Due diligence actions",
          type: "text",
          name: "PartnerDueDiligenceCall_actions",
        },
      ],
    },
    customComponentKey: "dueDiligenceDetails",
    enableColumnFilter: false,
    enableGlobalFilter: false,
    enableSorting: false,
  },
];

const PartnerAdditionalInfoField = [
  {
    componentType: "text",
    label: "Business experience",
    id: "PartnerQuestionnaire_business_experience",
  },
  {
    componentType: "text",
    label: "How do you keep up-to-date with business issues?",
    id: "PartnerQuestionnaire_up_to_date_with_business_issues",
  },
  {
    componentType: "datePicker",
    label: "Date you started coaching",
    id: "PartnerQuestionnaire_coaching_started_date",
  },
  {
    componentType: "multiSelect",
    label: "In which industry sectors have you delivered coaching to?",
    id: "PartnerQuestionnaire_sector_experience",
    addNewOption: true,
    optionsKey: "industry_sector_list_id",
    dropDown: "IndustrySectorList",
    field_name: "industry_sector",
  },
  {
    componentType: "text",
    label: "Workload distribution",
    id: "PartnerQuestionnaire_workload_distribution_executive",
  },
  {
    componentType: "multiSelect",
    label: "What complimentary services do you offer?",
    id: "PartnerQuestionnaire_complimentary_services",
    addNewOption: true,
    optionsKey: "complementary_service_id",
    dropDown: "ComplementaryService",
    field_name: "complementary_service",
  },
  {
    componentType: "dropdown",
    label: "Coach training hours",
    id: "PartnerQuestionnaire_coach_training_hours",
    optionsKey: "coach_training_hr_id",
  },
  {
    componentType: "dropdown",
    label: "Coaching hours",
    id: "PartnerQuestionnaire_coaching_hours",
    optionsKey: "coaching_hr_id",
  },
  {
    componentType: "text",
    label:
      "How do you evaluate and measure the success of your coaching assignments?",
    id: "PartnerQuestionnaire_evaluate_and_measure_coaching_assignments",
  },
  {
    componentType: "text",
    label: "Preferences - under what conditions do you get your best results?",
    id: "PartnerQuestionnaire_preferences",
  },
  {
    componentType: "text",
    label:
      "What are the criteria for you to have a good Associate/ Partner relationship with a managed service provider?",
    id: "PartnerQuestionnaire_criteria_for_good_relationship_with_service_provider",
  },
  {
    componentType: "multiSelect",
    label:
      "What industry sectors did you work in? e.g. Financial Services, IT, Retail",
    id: "PartnerQuestionnaire_sector_experience",
    addNewOption: true,
    optionsKey: "industry_sector_list_id",
    dropDown: "SectorExperience",
    field_name: "sector_experience",
  },
  {
    componentType: "multiSelect",
    label: "What disciplines did you work in?",
    id: "PartnerQuestionnaire_disciplines",
    addNewOption: true,
    optionsKey: "discipline_id",
    dropDown: "Discipline",
    field_name: "discipline",
  },
  {
    componentType: "multiSelect",
    label: "At what level did you work at?",
    id: "PartnerQuestionnaire_at_what_level",
    addNewOption: true,
    optionsKey: "at_what_level_id",
    drop_down: "AtWhatLevel",
    field_name: "at_what_level",
  },
  {
    componentType: "text",
    label: "What was your last job title?",
    id: "PartnerQuestionnaire_last_job_title",
  },
  {
    componentType: "text",
    label: "Most senior role held",
    id: "PartnerQuestionnaire_most_senior_role_held",
  },
  {
    componentType: "text",
    label: "What was your role experience?",
    id: "PartnerQuestionnaire_role_experience",
  },
  {
    componentType: "dropdown",
    label: "Have you worked in the public sector?",
    id: "PartnerQuestionnaire_worked_in_public_sector",
    optionsKey: "only_true_or_false",
  },
  {
    componentType: "dropdown",
    label: "Have you worked in the private sector?",
    id: "PartnerQuestionnaire_worked_in_private_sector",
    optionsKey: "only_true_or_false",
    dropDown: "value",
    field_name: "value",
  },
  {
    componentType: "multiSelect",
    label: "What levels do you coach at?",
    id: "PartnerQuestionnaire_at_what_level",
    addNewOption: true,
    optionsKey: "at_what_level_id",
    dropDown: "Level",
    field_name: "level",
  },
  {
    componentType: "text",
    label: "Summary bio",
    id: "PartnerQuestionnaire_thumbnail_bio",
  },
  {
    componentType: "dropdown",
    label: "Insurance in place Yes/No?",
    id: "PartnerQuestionnaire_insurance_in_place",
    optionsKey: "only_yes_or_no",
  },
  // {
  //   componentType: "dropdown",
  //   label: "Reference contanct details",
  //   id: "PartnerQuestionnaire_reference_contact_details",
  // },
  {
    componentType: "text",
    label: "Reference other",
    id: "PartnerQuestionnaire_reference_other",
  },
  {
    componentType: "text",
    label: "Additional information",
    id: "PartnerQuestionnaire_additional_information",
  },
];
const PartnerCommercialsAndDelivery = [
  {
    componentType: "multiSelect",
    label: "Coaching hourly rate",
    id: "PartnerExtraQuestion_coaching_hourly_rate",
    optionsKey: "coaching_hr_id",
  },
  {
    componentType: "multiSelect",
    label: "Facilitation day rates",
    id: "PartnerExtraQuestion_facilitation_day_rate",
    optionsKey: "facilitation_day_rate_id",
  },
  {
    componentType: "multiSelect",
    label: "Assessment day rates",
    id: "PartnerExtraQuestion_assessment_hourly_rate",
    optionsKey: "assessment_hour_rate_id",
  },
  // {
  //   componentType: "text",
  //   label: "Travel Expenses",
  //   id: "PartnerExtraQuestion_travel_expenses",
  // },
  {
    componentType: "text",
    label: "Psychometric costs",
    id: "PartnerExtraQuestion_psychometric_costs",
  },
  {
    componentType: "multiSelect",
    label: "Which cities would you NOT charge travel for",
    id: "PartnerExtraQuestion_local_tx_area",
    optionsKey: "city",
  },
  {
    componentType: "multiSelect",
    label: "Delivery method",
    id: "PartnerExtraQuestion_delivery_method",
    optionsKey: "delivery_method_id",
  },
  // {
  //   componentType: "text",
  //   label: "Levels Acuity would you NOT charge travel for?",
  //   id: "PartnerExtraQuestion_level",
  // },
];
const PartnerGeneralProfile = [
  {
    componentType: "multiSelect",
    label: "Suffix",
    id: "PartnerGeneralInfo_suffix",
    optionsKey: "suffix_id",
  },
  {
    componentType: "text",
    label: "City",
    id: "PartnerGeneralInfo_city",
  },
  {
    componentType: "dropdown",
    label: "Country",
    id: "PartnerGeneralInfo_country",
    optionsKey: "country_list_id",
  },
  {
    componentType: "text",
    label: "Background/Career history",
    id: "PartnerGeneralInfo_background",
    required: true,
  },
  {
    componentType: "text",
    label: "Education and qualifications",
    id: "PartnerGeneralInfo_educational_qualifications",
    required: true,
  },
  {
    componentType: "text",
    label: "Professional development and supervision",
    id: "PartnerGeneralInfo_professional_development_and_supervision",
  },
  {
    componentType: "multiSelect",
    label: "Professional affiliations",
    id: "PartnerGeneralInfo_professional_affiliations",
    optionsKey: "professional_affiliation_id",
    required: true,
    addNewOption: true,
  },
  {
    componentType: "multiSelect",
    label: "Languages",
    id: "PartnerGeneralInfo_languages",
    optionsKey: "language_list_id",
  },
  {
    componentType: "multiSelect",
    label: "Psychometric and diagnostic tools",
    id: "PartnerGeneralInfo_diagnostic_tools",
    optionsKey: "diagnostic_tool_id",
    required: true,
    addNewOption: true,
    field_name: "diagnostic_tool",
    dropDown: "DiagnosticTool",
  },
  {
    componentType: "text",
    label: "Personal interests",
    id: "PartnerGeneralInfo_personal_interests",
  },
  {
    componentType: "text",
    label: "Client testimonials",
    id: "PartnerGeneralInfo_client_testimonials",
  },
];

const ParnterCoachingProfile = [
  {
    componentType: "text",
    label: "Coaching overview",
    id: "PartnerCoachingProfile_overview",
    required: true,
  },
  {
    componentType: "text",
    label: "Coaching approach",
    id: "PartnerCoachingProfile_approach",
    required: true,
  },
  {
    componentType: "multiSelect",
    label: "Coaching areas of expertise",
    id: "PartnerCoachingProfile_coaching_areas_of_expertise",
    required: true,
    optionsKey: "coaching_areas_of_expertise_id",
  },
  {
    componentType: "text",
    label: "Representative coaching engagements",
    id: "PartnerCoachingProfile_representative_engagements",
    required: true,
  },
  {
    componentType: "multiSelect",
    label: "Level of clients coached",
    id: "PartnerCoachingProfile_level_of_clients_coached",
    required: true,
    addNewOption: true,
  },
  {
    componentType: "text",
    label: "Representative clients",
    id: "PartnerCoachingProfile_represntative_clients",
    required: true,
  },
  {
    componentType: "text",
    label: "Client coaching testimonials",
    id: "PartnerCoachingProfile_client_coaching_testimonials",
    required: true,
  },
];

const PartnerFacilitationProfile = [
  {
    componentType: "text",
    label: "Facilitation experience overview",
    id: "PartnerFacilitationProfile_facilitation_exp_overview",
    required: true,
  },
  {
    componentType: "text",
    label: "Facilitation topics",
    id: "PartnerFacilitationProfile_topics",
    required: true,
  },
  {
    componentType: "multiSelect",
    label: "Facilitation areas of expertise",
    id: "PartnerFacilitationProfile_facilitation_areas_of_expertise",
    required: true,
    addNewOption: true,
    optionsKey: "facilitation_areas_of_expertise_id",
    dropDown: "FacilitationAreasOfExpertise",
    field_name: "facilitation_areas_of_expertise",
  },
  {
    componentType: "text",
    label: "Representative facilitation programmes",
    id: "PartnerFacilitationProfile_representative_facilitation_programmes",
    required: true,
  },
  {
    componentType: "text",
    label: "Facilitation clients",
    id: "PartnerFacilitationProfile_facilitation_clients",
    required: true,
  },
  {
    componentType: "text",
    label: "Client facilitation testimonials",
    id: "PartnerFacilitationProfile_client_testimonials",
    required: true,
  },
];

const PartnerMentoringProfile = [
  {
    componentType: "text",
    label: "Mentoring overview",
    id: "PartnerMentoringProfile_overview",
    required: true,
  },
  {
    componentType: "text",
    label: "Mentoring approach",
    id: "PartnerMentoringProfile_approach",
    required: true,
  },
  {
    componentType: "multiSelect",
    label: "Mentoring areas of expertise",
    id: "PartnerMentoringProfile_mentoring_areas_of_expertise",
    required: true,
    optionsKey: "mentoring_areas_of_expertise_id",
  },
  {
    componentType: "text",
    label: "Representative mentoring engagements",
    id: "PartnerMentoringProfile_representative_engagements",
    required: true,
  },
  {
    componentType: "text",
    label: "Levels of clients mentored",
    id: "PartnerMentoringProfile_clients_mentored",
    required: true,
  },
  {
    componentType: "text",
    label: "Representative clients",
    id: "PartnerMentoringProfile_representative_clients",
    required: true,
  },
  {
    componentType: "text",
    label: "Client mentoring testimonials",
    id: "PartnerMentoringProfile_client_testimonials",
    required: true,
  },
];

const PartnerAssessmentProfile = [
  {
    componentType: "text",
    label: "Assessment experience overview",
    id: "PartnerAssessmentProfile_assessment_exp_overview",
    required: true,
  },
  {
    componentType: "multiSelect",
    label: "Types of assessment",
    id: "PartnerAssessmentProfile_types_of_assessment",
    required: true,
    addNewOption: true,
    optionsKey: "type_of_assessment_id",
    drop_down: "TypeOfAssessment",
    field_name: "type_of_assessment",
  },
  {
    componentType: "text",
    label: "Representative assessment engagements",
    id: "PartnerAssessmentProfile_representative_engagements",
    required: true,
  },
  {
    componentType: "text",
    label: "Assessment clients",
    id: "PartnerAssessmentProfile_assessment_clients",
    required: true,
  },
  {
    componentType: "text",
    label: "Client assessment testimonials",
    id: "PartnerAssessmentProfile_assessment_clients_testimonials",
    required: true,
  },
];

const PartnerDocumentation = [
  // {
  //   componentType: "uploadFiles",
  //   label: "Documents",
  //   id: "PartnerContractDocument_documents",
  // enableColumnFilter: false,
  // enableGlobalFilter: false,
  // enableSorting: false,
  // },
];

const PartnerCommissionInformation = [
  {
    componentType: "dropdown",
    label: "Commission",
    id: "PartnerCommissionInformation_commission",
    optionsKey: "only_true_or_false",
  },
  {
    componentType: "text",
    label: "Commission rate",
    id: "PartnerCommissionInformation_commission_rate",
  },
  {
    componentType: "dropdown",
    label: "Commission currency",
    id: "PartnerCommissionInformation_commission_currency",
    optionsKey: "currency",
  },
  {
    componentType: "text",
    label: "Commission notes",
    id: "PartnerCommissionInformation_commission_notes",
  },
  {
    componentType: "text",
    label: "Commission period",
    id: "PartnerCommissionInformation_commission_period",
  },
  {
    componentType: "text",
    label: "Commission total",
    id: "PartnerCommissionInformation_commission_total",
  },
];

const PartnerAssociateCoaches = [
  {
    componentType: "text",
    label: "Associate job role",
    id: "PartnerAssociateCoache_job_role",
  },
  {
    componentType: "text",
    label: "Associate bio paragraph",
    id: "PartnerAssociateCoache_bio_paragraph",
  },
];

const PartnerGDPR = [
  {
    componentType: "dropdown",
    label: "Consent status",
    id: "PartnerGdpr_consent_status",
    optionsKey: "only_true_or_false",
  },
  {
    componentType: "datePicker",
    label: "Consent expiry date",
    id: "PartnerGdpr_consent_expiry_date",
  },
  {
    componentType: "text",
    label: "Consent terms",
    id: "PartnerGdpr_consent_terms",
  },
  {
    componentType: "dropdown",
    label: "Lawful bias",
    id: "PartnerGdpr_lawful_bias",
    optionsKey: "lawful_bia_id",
  },
  {
    componentType: "multiSelect",
    label: "Purposes",
    id: "PartnerGdpr_purposes",
    optionsKey: "purpose_id",
  },
  {
    componentType: "dropdown",
    label: "Contact status (do not contact, do not mailshot etc)",
    id: "PartnerGdpr_contact_status",
    optionsKey: "contact_status_id",
  },
];

export const partnerGroupedColumns = [
  {
    id: "partner_details",
    groupName: "Information and contact area",
    columns: PartnerInformationFormFields,
  },
  {
    id: "partner_panel_access",
    groupName: "Panel access",
    columns: PartnerPanelAccessField,
  },
  {
    id: "partner_nda",
    groupName: "Non Disclosure Agreement(NDA)",
    columns: PartnerNDAField,
  },
  {
    id: "partner_wwa",
    groupName: "Working with Acuity Coaching(WWA)",
    columns: PartnerWWAField,
  },
  {
    id: "partner_due_diligence",
    groupName: "Due diligence",
    columns: ParnterDiligenceField,
  },
  {
    id: "partner_additional_info",
    groupName: "Additional partner Information",
    columns: PartnerAdditionalInfoField,
  },
  {
    id: "partner_commercials_and_delivery",
    groupName: "Commercials and delivery",
    columns: PartnerCommercialsAndDelivery,
  },
  {
    id: "partner_general_profile",
    groupName: "General profile fields",
    columns: PartnerGeneralProfile,
  },
  {
    id: "partner_coaching_profile",
    groupName: "Coaching profile fields",
    columns: ParnterCoachingProfile,
  },
  {
    id: "partner_facilitation_profile",
    groupName: "Facilitation profile fields",
    columns: PartnerFacilitationProfile,
  },
  {
    id: "partner_mentoring_profile",
    groupName: "Mentoring profile fields",
    columns: PartnerMentoringProfile,
  },
  {
    id: "partner_assessment_profile",
    groupName: "Assessment profile fields",
    columns: PartnerAssessmentProfile,
  },
  {
    id: "partner_documentation",
    groupName: "Documentation",
    columns: PartnerDocumentation,
  },
  {
    id: "partner_commission_information",
    groupName: "Commission information",
    columns: PartnerCommissionInformation,
  },
  {
    id: "partner_associate_coaches",
    groupName: "Associate coaches",
    columns: PartnerAssociateCoaches,
  },
  {
    id: "partner_gdpr",
    groupName: "GDPR",
    columns: PartnerGDPR,
  },
];
